import { useEffect, useState } from 'react';
import debounce from 'lodash-es/debounce';
import noop from 'lodash-es/noop';

import type { HandlerRef } from '..';
import { RESIZE_LISTENER_DEBOUNCE, SwipeDirection } from '../constants';

export const useControls = (handlerRef: HandlerRef, scroll: number) => {
  const [hasNext, setHasNext] = useState(false);
  const [hasPrev, setHasPrev] = useState(false);

  useEffect(() => {
    const handleControls = debounce(() => {
      if (handlerRef.current) {
        const { isScrollable } = handlerRef.current;
        setHasPrev(isScrollable(scroll, SwipeDirection.Prev));
        setHasNext(isScrollable(scroll, SwipeDirection.Next));
      }
    }, RESIZE_LISTENER_DEBOUNCE);

    handleControls();

    window.addEventListener('resize', handleControls);

    return () => window.removeEventListener('resize', handleControls);
  }, [scroll]);

  if (handlerRef.current) {
    const { swipe } = handlerRef.current;

    const swipePrev = () => swipe(SwipeDirection.Prev);
    const swipeNext = () => swipe(SwipeDirection.Next);

    return { swipePrev, swipeNext, hasPrev, hasNext };
  }

  return { swipePrev: noop, swipeNext: noop, hasPrev: false, hasNext: false };
};
